<template>
    <div>
        <md-dialog :md-active.sync="show"
                   :md-fullscreen="true"
                   :md-click-outside-to-close="false"
                   :md-close-on-esc="false">


            <md-dialog-title class="text-center">
                สามารถปรับค่าใช้จ่ายที่ต้องการใช้ต่อเดือน โดยระบุจำนวนที่ต้องการเอง
            </md-dialog-title>

            <md-dialog-content>

                <div class="mb-3">
                    <div class="row align-items-center">
                        <div class="col-12 col-md-auto form-group">
                            <div class="label no-padding">
                                ค่าอาหาร (บาท)
                            </div>
                        </div>

                        <div class="col form-group input-group-lg">

                            <money v-bind="money" v-model="form.spendingMonthFood"
                                   class="form-control"
                                   placeholder="โปรดระบุ"></money>
                        </div>
                    </div>


                    <div class="row align-items-center">
                        <div class="col-12 col-md-auto form-group">
                            <div class="label no-padding">
                                ค่าสาธารณูปโภค  (บาท)
                            </div>
                        </div>

                        <div class="col form-group input-group-lg">
                            <money v-bind="money" v-model="form.spendingMonthUtility"
                                   class="form-control"
                                   placeholder="โปรดระบุ"></money>
                        </div>
                    </div>


                    <div class="row align-items-center">
                        <div class="col-12 col-md-auto form-group">
                            <div class="label no-padding">
                                ค่าของใช้ส่วนตัว  (บาท)
                            </div>
                        </div>

                        <div class="col form-group input-group-lg">
                            <money v-bind="money" v-model="form.spendingMonthPersonal"
                                   class="form-control"
                                   placeholder="โปรดระบุ"></money>
                        </div>
                    </div>


                    <div class="row align-items-center">
                        <div class="col-12 col-md-auto form-group">
                            <div class="label no-padding">
                                เพื่อความบันเทิง  (บาท)
                            </div>
                        </div>

                        <div class="col form-group input-group-lg">
                            <money v-bind="money" v-model="form.spendingMonthEntertainment"
                                   class="form-control"
                                   placeholder="โปรดระบุ"></money>
                        </div>
                    </div>


                    <div class="row align-items-center">
                        <div class="col-12 col-md-auto form-group">
                            <div class="label no-padding">
                                สำหรับท่องเที่ยว  (บาท)
                            </div>
                        </div>

                        <div class="col form-group input-group-lg">
                            <money v-bind="money" v-model="form.spendingMonthVacation"
                                   class="form-control"
                                   placeholder="โปรดระบุ"></money>
                        </div>
                    </div>


                    <div class="row align-items-center">
                        <div class="col-12 col-md-auto form-group">
                            <div class="label no-padding">
                                ค่ารักษาพยาบาล  (บาท)
                            </div>
                        </div>

                        <div class="col form-group input-group-lg">
                            <money v-bind="money" v-model="form.spendingMonthMedical"
                                   class="form-control"
                                   placeholder="โปรดระบุ"></money>
                        </div>
                    </div>
                </div>


                <div class="text-center mb-3">
                    รวมค่าใช้จ่ายที่ต้องการใช้ <span class="txt-primary md-title"> {{data.spendingPerMonth | setNumberFormat}} </span>
                    บาท/เดือน
                </div>



                <div class="text-center">
                    <div class="button-yellow" @click="confirm(data)">
                        ตกลง
                    </div>
                </div>
            </md-dialog-content>

        </md-dialog>
    </div>
</template>

<script>

  export default {
    name: 'DialogSpendingPerMonth',
    props: {
      dialog: Object,
      show: Boolean,
      data: Object
    },
    data: () => ({
      errorMessage: {},
      form: {
        spendingMonthFood: 0,
        spendingMonthUtility: 0,
        spendingMonthPersonal: 0,
        spendingMonthEntertainment: 0,
        spendingMonthVacation: 0,
        spendingMonthMedical: 0,
      },
      money: {
        thousands: ',',
        precision: 0,
        masked: false
      }
    }),
    methods: {
      confirm: function () {
        let data = {
          spendingPerMonth: this.data.spendingPerMonth,
          detail: this.form
        };

        this.$emit('close', data);
      }
    },

    watch: {
      form: {
        handler(val) {
          this.data.spendingPerMonth =
            parseFloat(val.spendingMonthFood ? val.spendingMonthFood : 0) +
            parseFloat(val.spendingMonthUtility ? val.spendingMonthUtility : 0) +
            parseFloat(val.spendingMonthPersonal ? val.spendingMonthPersonal : 0) +
            parseFloat(val.spendingMonthEntertainment ? val.spendingMonthEntertainment : 0) +
            parseFloat(val.spendingMonthVacation ? val.spendingMonthVacation : 0) +
            parseFloat(val.spendingMonthMedical ? val.spendingMonthMedical : 0);
        },
        deep: true
      }
    }

  }
</script>


<style scoped lang="scss">
    @import "../assets/css/colors";

    .error-message {
        color: $danger;
    }

    .button-accent {
        margin-right: 5px;
    }

    .md-dialog {
        font-size: 22px;
        min-width: 40%;
        color: $navy !important;
    }

    .label {
        min-width: 210px;
    }


    @media only screen and (max-width: 768px) {
        .md-dialog {
            font-size: 22px;
            min-width: 80%;
        }
    }

</style>
